import { axios } from '@Root/API'

export const edit = html => {
	return axios.put('content/application-form/edit', {
		html,
	})
}
